export class RedVariety {

    constructor(readonly name: string) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/RedVariety.ts